class SideScroller extends HTMLElement {
  constructor() {
    super();
    this._isDragging = false;
    this._didDrag = false;
    this._startX = 0;
    this._scrollLeft = 0;
    this._dragThreshold = 5; // px

    this._resizeObserver = null;

    this._handleScroll = this._handleScroll.bind(this);
    this._handleMouseDown = this._handleMouseDown.bind(this);
    this._handleMouseMove = this._handleMouseMove.bind(this);
    this._stopDragging = this._stopDragging.bind(this);
    this._handleClickCapture = this._handleClickCapture.bind(this);
  }

  connectedCallback() {
    const container = this.querySelector(".scrollable-container");
    if (!container) return;
    container.addEventListener("scroll", this._handleScroll);
    container.addEventListener("mousedown", this._handleMouseDown);
    container.addEventListener("mousemove", this._handleMouseMove);
    container.addEventListener("mouseup", this._stopDragging);
    container.addEventListener("mouseleave", this._stopDragging);
    // captura clique antes que chegue no <a>/<button> filho
    container.addEventListener("click", this._handleClickCapture, true);
    container.dispatchEvent(new Event("scroll"));

    // Havendo ou não transbordo só dá para saber medindo, e a medida muda com
    // resize, fonte carregada tarde e conteúdo trocado. Sem observar, os
    // gradientes ficam congelados no estado do primeiro cálculo — some o
    // indicador num trilho que passou a rolar, ou sobra num que deixou de rolar.
    if ("ResizeObserver" in window) {
      this._resizeObserver = new ResizeObserver(() => this._updateScrollState(container));
      this._resizeObserver.observe(container);
      Array.from(container.children).forEach((child) => this._resizeObserver.observe(child));
    }
  }

  disconnectedCallback() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }

    const container = this.querySelector(".scrollable-container");
    if (!container) return;
    container.removeEventListener("scroll", this._handleScroll);
    container.removeEventListener("mousedown", this._handleMouseDown);
    container.removeEventListener("mousemove", this._handleMouseMove);
    container.removeEventListener("mouseup", this._stopDragging);
    container.removeEventListener("mouseleave", this._stopDragging);
    container.removeEventListener("click", this._handleClickCapture, true);
  }

  _updateScrollState(container) {
    const maxLeft = Math.max(0, container.scrollWidth - container.clientWidth);
    const scrollOffset = 10;
    this.classList.toggle("can-scroll-left", container.scrollLeft > scrollOffset);
    this.classList.toggle("can-scroll-right", container.scrollLeft < maxLeft - scrollOffset);
  }

  _handleScroll(e) {
    this._updateScrollState(e.currentTarget);
  }

  _handleMouseDown(e) {
    const container = e.currentTarget;
    this._isDragging = true;
    this._didDrag = false;
    this._startX = e.pageX - container.offsetLeft;
    this._scrollLeft = container.scrollLeft;
    container.style.cursor = "grabbing";
    container.style.userSelect = "none";
    e.preventDefault();
  }

  _handleMouseMove(e) {
    if (!this._isDragging) return;
    const container = e.currentTarget;
    const x = e.pageX - container.offsetLeft;
    const walk = x - this._startX;

    if (Math.abs(walk) > this._dragThreshold) {
      this._didDrag = true;
    }

    container.scrollLeft = this._scrollLeft - walk;
  }

  _stopDragging(e) {
    const container = e.currentTarget;
    this._isDragging = false;
    container.style.cursor = "";
    container.style.userSelect = "";
    // não zera _didDrag aqui: o click ainda vai disparar logo em seguida
    // e é nesse click que precisamos bloquear a navegação
  }

  _handleClickCapture(e) {
    if (this._didDrag) {
      e.preventDefault();
      e.stopPropagation();
      this._didDrag = false;
    }
  }
}

customElements.define("side-scroller", SideScroller);
